import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, filter, map, take } from 'rxjs/operators';
import { CaseService } from '../../admin/case/case.service';
import { MainGlobalEventService } from '../services/main-global-event.service';

@Injectable({
  providedIn: 'root'
})
export class RestrictFromPackagersGuard {

  constructor(
    private router: Router,
    private globalEventsService: MainGlobalEventService,
    private caseService: CaseService
  ) {
  }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const caseId = +this.findCaseId(route);
    console.log('guard id' + caseId);
    if ( ! caseId) {
      console.warn('No case ID found in route hierarchy.');
      this.router.navigate(['/']);
      return of(false);
    }
    return forkJoin([
      this.globalEventsService.authUser$.pipe(
        filter(user => user !== null),
        take(1)
      ),
      this.caseService.get(caseId, ['transfer_request']).pipe(
        catchError(() => {
          console.error('Failed to retrieve case');
          this.router.navigate(['/']);
          return of(null);
        })
      )
    ]).pipe(
      map(([user, caseData]) => {
        if ( ! user || ! caseData) {
          return false;
        }

        const isNonMasterPackager = user.packager?.master === false;
        const transferAccepted    = caseData.data.transfer_request?.accepted === true;
        const updatableByPackager = caseData.data.updatable_by_packager;
        if (isNonMasterPackager && transferAccepted && ! updatableByPackager) {
          console.log('redirecting from guard');
          this.router.navigate(['cases', caseId, 'detail', 'snapshot']);
          return false;
        }

        return true;
      })
    );
  }

  private findCaseId(route: ActivatedRouteSnapshot): string | null {
    let currentRoute: ActivatedRouteSnapshot | null = route;
    while (currentRoute) {
      const id = currentRoute.paramMap.get('id');
      if (id) {
        return id;
      }
      currentRoute = currentRoute.parent!;
    }
    return null;
  }
}
